export class NewValidationResult {
    isValid: boolean;
    message: string;
    messagesPerControls: object;

  constructor(
    isValid: boolean = false,
    message: string = '',
    messagesPerControls: object = {},
  ) {
    this.isValid = isValid
    this.message = message
    this.messagesPerControls = messagesPerControls
  }

}
